module.exports = __webpack_public_path__ + "media/topSection/top-section-3-6b88d47d.jpg";